import type { SectionWidgetConfig } from '../../types';
import { SportsWidgetType } from '../../widgets';
import { buildSportsLayoutPageResponse } from '../buildSportsLayoutPageResponse';

import {
  TXTWCL_Bet_on_Golf_matches_with_Poker_ELL,
  TXTWCL_Golf_Match_Betting_X_Golf_Matc_ELL
} from './sportsGolfMatches.messages.json';

const sportsGolfMatchesWidgets = [
  {
    title: 'Sports CMS Banner Widget',
    _content_type_uid: SportsWidgetType.SportsCmsBanner,
    boxShadow: true
  },
  {
    title: 'Sports Golf Matches Widget',
    _content_type_uid: SportsWidgetType.SportsGolfMatches
  }
] satisfies readonly SectionWidgetConfig[];

export const sportsGolfMatches = buildSportsLayoutPageResponse({
  alias: 'sportsGolfMatches',
  seoConfig: {
    descriptionTag: TXTWCL_Bet_on_Golf_matches_with_Poker_ELL,
    titleTag: TXTWCL_Golf_Match_Betting_X_Golf_Matc_ELL
  },
  mainSectionWidgetConfigs: sportsGolfMatchesWidgets
});
